import { ErrorFallback } from '@components/error/fallback/ErrorFallback';
import { getLogger } from '@lib/logger';
import { ErrorBoundary } from 'react-error-boundary';
import type { PropsWithChildren } from 'react';

export function CustomErrorBoundary({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, errorInfo) => {
        getLogger({ scope: 'app.error-boundary' }).error('Unhandled React render error', {
          error,
          attributes: errorInfo.componentStack
            ? { 'react.component-stack': errorInfo.componentStack }
            : undefined,
        });
      }}
      onReset={() => {
        window.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
